<script setup>
const props = defineProps({
  image: { type: Object },
  info: { type: String },
  title: { type: String },
  text: { type: String },
  button: { type: Object },
})
</script>

<template>
  <NuxtLink
    :to="props.button?.to || '#'"
    class="d-fluid flex-column flex-1200-row flex-800-column flex-640-row recipe-teaser"
  >
    <div class="recipe-teaser__image">
      <NuxtImg
        v-if="props.image?.src"
        class="img-fluid"
        :src="props.image?.src"
        :alt="props.image?.alt"
        sizes="sm:340px md:440px lg:800px"
        densities="1x 2x"
        loading="lazy"
        format="webp"
        :placeholder="[300, 200, 60, 2]"
      />
    </div>
    <div class="recipe-teaser__content">
      <div
        class="equal-small-2 equal-small-2--bold-uppercase recipe-teaser__info"
      >
        {{ props.info }}
      </div>
      <h3
        class="equal-base equal-base--tighter-bold-uppercase recipe-teaser__title"
      >
        {{ props.title }}
      </h3>
      <div class="equal-base equal-base--tighter recipe-teaser__text">
        {{ props.text }}
      </div>
      <FormButton
        :label="props.button?.label"
        class="l-button--outlined recipe-teaser__button"
      />
    </div>
  </NuxtLink>
</template>

<style lang="scss" scoped>
@import '~/assets/scss/variables.scss';
@import 'bootstrap/scss/mixins';

.recipe-teaser {
  display: flex;
  overflow: hidden;
  border-radius: 12px;
  background-color: $color-dark-03;
  transition: 0.5s ease;

  text-decoration: none;

  &:hover,
  &:focus,
  &:active {
    background-color: $color-dark-02;
    transition: 0.5s ease;

    .recipe-teaser__image {
      img {
        transform: scale(1.05);
        transition: 0.5s ease;
      }
    }
  }

  &__content {
    width: 50%;
    margin: auto;
    padding: 40px;

    @include media-breakpoint-down(1200) {
      width: unset;
      padding: 25px 20px;
    }
    @include media-breakpoint-down(800) {
      width: 50%;
      padding: 40px;
    }
    @include media-breakpoint-down(640) {
      width: unset;
      padding: 25px 20px;
    }
  }

  &__info {
    color: $color-disabled;
  }

  &__title {
    margin-bottom: 10px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &__text {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &__image {
    width: 50%;
    max-height: 100%;
    overflow: hidden;

    @include media-breakpoint-down(1200) {
      width: unset;
      max-height: 270px;
    }
    @include media-breakpoint-down(800) {
      width: 50%;
    }
    @include media-breakpoint-down(640) {
      width: unset;
    }

    img {
      transition: 0.5s ease;
      width: 100%;
      height: 100%;
      object-fit: cover;
      overflow: hidden;
    }
  }

  &__button {
    margin-top: 20px;
  }
}
</style>
